module.exports = __webpack_public_path__ + "static/media/16.2808b8a3.JPG";